/* @ngInject */
export default function LearnerDirectoryAllFiltersModalController(
  LearnerDirectoryManager,
) {
  const vm = this;
  vm.manager = LearnerDirectoryManager;
}
